import { generateContentfulClient } from "./generateContentfulClient";

export const contentfulClient = generateContentfulClient("/api/content");
